import { useAtom } from "jotai";
import { atomWithStorage } from "jotai/utils";

import { LIQUIDATION_WARNING_THRESHOLDS } from "#/config/settings";

export const liquidationWarningThresholdsAtom = atomWithStorage<number[]>(
  "liquidationWarningThresholds",
  LIQUIDATION_WARNING_THRESHOLDS.filter((threshold) => threshold >= 0.8),
  undefined,
  { getOnInit: true },
);

export const useLiquidationWarningThresholds = () => {
  const [liquidationWarningThresholds, setLiquidationWarningThresholds] =
    useAtom(liquidationWarningThresholdsAtom);

  return {
    liquidationWarningThresholds,
    setLiquidationWarningThresholds,
  };
};
